import axios from "axios";
// import Swal from "sweetalert2"; // <-- REMOVED


const serverURL = "https://new.zaptodoor.com";

async function getData(url) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.get(`${serverURL}/${url}`, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return { data: null, error: e.message || "Request failed" };
  }
}


async function postData(url, body) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.post(`${serverURL}/${url}`, body, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return { data: null, error: e.message || "Request failed" };
  }
}

function getDate() {
  const cd = new Date();
  return `${cd.getFullYear()}/${cd.getMonth() + 1}/${cd.getDate()}`;
}

function getTime() {
  const cd = new Date();
  return `${cd.getHours()}:${cd.getMinutes()}:${cd.getSeconds()}`;
}
async function putData(url, body) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.put(`${serverURL}/${url}`, body, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return { data: null, error: e.message || "Request failed" };
  }
}

async function deleteData(url) {
  try {
    const config = {
      headers: {
        Authorization: `${localStorage.getItem("Token")}`,
      },
    };
    const response = await axios.delete(`${serverURL}/${url}`, config);
    return response.data;
  } catch (e) {
    console.error(e);
    return { data: null, error: e.message || "Request failed" };
  }
}

export { getData, postData, putData, deleteData, serverURL, getDate, getTime };

